import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, Select } from "antd";

const CustomerBasicDetails = ({ address, onSave, onCancel, isSaving }) => {
  const [form] = Form.useForm();

  // Load initial values when prop changes
  useEffect(() => {
    form.setFieldsValue(address);
  }, [address, form]);

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        onSave({ ...address, ...values }); // pass updated fields to parent
      })
      .catch((err) => console.log("Validation failed:", err));
  };

  return (
    <Form form={form} layout="vertical" initialValues={address} style={{ padding: 16 }}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input placeholder="Enter name" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="email" label="Email" rules={[{ required: true }, { type: "email", message: "Invalid email" }]}>
            <Input placeholder="Email" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="phone" label="Phone">
            <Input placeholder="Phone" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Row justify={"end"}>
          <Button loading={isSaving} disabled={isSaving} onClick={onCancel}>
            Cancel
          </Button>
          <Button loading={isSaving} disabled={isSaving} type="primary" style={{ marginLeft: 10, backgroundColor: "#ae9572", color: "black" }} onClick={handleSave}>
            Save
          </Button>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default CustomerBasicDetails;
